import { UserStatus } from "@sitescene/types";

import { BadgeColors } from "@/components/ui/badges/badge-types";

/** Invited users have not accepted yet; phone and notification columns show N/A. */
export const isInvitedUserStatus = (status: string | UserStatus): boolean =>
	status === UserStatus.Invited;

/** Joins first and last name, dropping empty parts. */
export const formatUserName = (
	firstName?: null | string,
	lastName?: null | string,
): string => [firstName, lastName].filter(Boolean).join(" ");

type UserStatusBadgeConfig = {
	color: BadgeColors;
	label: string;
};
export const getUserStatusBadgeConfig = (
	status: UserStatus,
): UserStatusBadgeConfig => {
	switch (status) {
		case UserStatus.Active:
			return {
				color: "success",
				label: "Active",
			};
		case UserStatus.Deactivated:
			return {
				color: "error",
				label: "Deactivated",
			};
		case UserStatus.Deleted:
			return {
				color: "warning",
				label: "Deleted",
			};
		case UserStatus.Invited:
			return {
				color: "sky",
				label: "Invited",
			};
		default:
			return {
				color: "gray",
				label: "Unknown",
			};
	}
};
